import { useState } from 'react';
import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import SocialIcon from '../components/SocialIcon';
import { Field } from '../components/ui';
import { SOCIAL_LINKS } from '../components/layout/navConfig';
import { useToast } from '../context/ToastContext';

export default function Contact() {
  const toast = useToast();
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  function submit(e) {
    e.preventDefault();
    // No public contact endpoint in the delivered API — flagged for backend-dev.
    toast.info('Thanks! A contact endpoint is not yet available — your message was not sent.');
    setForm({ name: '', email: '', message: '' });
  }

  return (
    <>
      <Seo title="Contact" description="Get in touch with Zonta District 17 Area 1." />
      <PageHero
        eyebrow="Get In Touch"
        title="Let's connect"
        subtitle="We'd love to hear from you. Reach out to get involved."
        image="/img/hero-leader.jpg"
      />

      <section className="container-page grid gap-10 py-16 lg:grid-cols-2">
        <div>
          <h2 className="heading-brand text-2xl">Get in touch</h2>
          <p className="mt-3 text-ink-soft">
            Whether you're interested in membership, volunteering, or partnerships, send us a message.
          </p>
          <div className="mt-6 space-y-3 text-ink-soft">
            <p>📧 <a href="mailto:zontad17a12026@gmail.com" className="text-maroon-700 hover:underline">zontad17a12026@gmail.com</a></p>
            <p>📍 District 17, Area 1</p>
          </div>
          <div className="mt-6 flex gap-3">
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-maroon-50 text-maroon-700 transition hover:bg-maroon-100"
                aria-label={`${s.label} (opens in a new tab)`}
                title={s.label}
              >
                <SocialIcon name={s.icon} label={s.label} className="h-[18px] w-[18px]" />
              </a>
            ))}
          </div>
        </div>

        <form onSubmit={submit} className="card space-y-5 p-6">
          <Field label="Name">
            <input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
          </Field>
          <Field label="Email">
            <input type="email" className="input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          </Field>
          <Field label="Message">
            <textarea className="input" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required />
          </Field>
          <button type="submit" className="btn-primary w-full">
            Send message
          </button>
        </form>
      </section>
    </>
  );
}
